import mutations from './feuImport.mutations'
import actions from './feuImport.actions'
import getters from './feuImport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
